// extracted by mini-css-extract-plugin
export default {"SignUpTitle":"iStyles_SignUpTitle__AVw54","SignUpSubtitle":"iStyles_SignUpSubtitle__R7Tqr"};